import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";



import {
  getInventoriesList as getInventoriesListAction,
  addStorage as addStorageAction,
  updateInventories as updateInventoriesAction,
} from "../../redux/modules/storage";



import UiInputSearch from "../../components/inputs/UiInputSearch";
import UiButtonColor from "../../components/button/UiButtonColor";
import UiModalProductAdd from "../../components/modals/UiModalProductAdd";
import UiPageText from "../../components/text/UiPageText";
import UiTableAdaptive from "../../components/table/UiTableAdaptive";

import "./ProductsStyle.scss";
import Env from "../../services/Env";
import { retrieveData, storeData } from "../../services/Storage";

function InventoriesPage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalDealAddACtive, setModalDealAddActive] = useState(false);
  const [searchLine, setSearchLine] = useState("");
  const [categoriesList, setCategoriesList] = useState([]);

  const [storageList, setStorageList] = useState([]);

  const clientsTitles = [
    { sort: false, title: "#" },
    { sort: false, title: "Название" },
    { sort: true, title: "Цена" },
    { sort: false, title: "Удалить" },
  ];
  const [tableListOrders, setTableListOrders] = useState([]);

  function _load() {
    let search = retrieveData("SEARCH_LINE");

    props.getInventoriesList().then((data) => {
      if (data) setStorageList(data.data);
      if (search) _search(search)
    });


  }

  function _search(_searchLine) {
    setSearchLine(_searchLine);
    storeData("SEARCH_LINE", _searchLine);

  }

  useEffect(() => {
    _load();
  }, [id]);



  useEffect(() => {
    if (searchLine != "") {
      _search(searchLine)
    } else {
      storeData("SEARCH_LINE", null);
      _load()
    }
  }, [searchLine])


  useEffect(() => {
    let arr = [];
    storageList.sort((a,b) => a.title.localeCompare(b.title)).map((item, index) => {
      arr.push([
        { text: index + 1 },
        { text: item.title },
        {
          inputPrice: true,
          inputPriceValue: item.price,
          onBlurInputPrice: (v) => {
            let _item = item;
            _item.price = v;
            props.updateInventories(_item).then(() => _load());
          }
        },
        {
          button: "delete",
          color: "red",
          onClick: () => {
            if (window.confirm("Удалить элемент ?")) {
              let _item = item;
              _item.is_del = item.is_del == 1 ? 0 : 1;
              props.updateInventories(_item).then(() => _load());
            }
          },
        },
      ]);
    });
    setTableListOrders(arr);
  }, [storageList]);

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
        <div className="home-info-text">
          <UiPageText
            title={`Склад номенклатуры`}
          />
        </div>
        <div className="home-info-button">
          <UiButtonColor
            color="indigo"
            text="Добавить"
            small={true}
            onClick={() => {
              storeData("edit", null);
              navigate("/inventories/add");
            }}
          />
        </div>
      </section>
      <section className="page-content">
        <div className="page-search">
          <UiInputSearch
            placeholder="Поиск:"
            value={searchLine}
            onChange={(val) => setSearchLine(val)}
          />
        </div>


        <UiTableAdaptive
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableListOrders}
        />
      </section>
      {/* modal deal add */}
      <UiModalProductAdd
        modalActive={modalDealAddACtive}
        modalClose={() => setModalDealAddActive(false)}
        findUserEvent={props.getUsersByPhone}
        prices={props.settings.prices}
        onCreate={(data) => {
          props.addOrder(data).then(() => {
            setModalDealAddActive(false);
          });
        }}
      />
    </div>
  );
}

export default connect(
  ({ storage, login, comment, logs, user, settings, category }) => ({
    storage,
    login,
    comment,
    logs,
    user,
    settings,
    category,
  }),
  {
    getInventoriesList: getInventoriesListAction,
    addStorage: addStorageAction,
    updateInventories: updateInventoriesAction,
  }
)(InventoriesPage);
